import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { site } from '@yola/ws-sdk';
import useFeatureFlags from 'yola-editor/src/js/modules/feature-flags/hooks/use-feature-flags';
import ai from '../../ai';

const {
  constants: {
    siteProperties: { UNSPLASH_SEARCH_QUERY_PROPERTY_NAME, UNSPLASH_SEARCH_QUERY_MAX_LENGTH },
  },
  helpers: { getUnsplashSearchQuery },
} = ai;

function useSearchQuery() {
  const dispatch = useDispatch();
  const siteProperties = useSelector(site.selectors.getSiteProperties);
  const siteSettings = useSelector(site.selectors.getSettings);

  const [featureFlags] = useFeatureFlags(['ai_unsplash_search_query']);
  const { ai_unsplash_search_query: isAiUnsplashSearchQueryEnabled } = featureFlags;

  const getInitialSearchQuery = useCallback(async () => {
    if (!isAiUnsplashSearchQueryEnabled) {
      return '';
    }

    const storedValue = siteProperties[UNSPLASH_SEARCH_QUERY_PROPERTY_NAME];

    if (storedValue) {
      return storedValue;
    }

    if (!siteSettings.businessDescription) {
      return '';
    }

    const generatedValue = await getUnsplashSearchQuery();

    if (generatedValue) {
      dispatch(site.actions.setSiteProperty(UNSPLASH_SEARCH_QUERY_PROPERTY_NAME, generatedValue));
    }

    return generatedValue;
  }, [isAiUnsplashSearchQueryEnabled, siteProperties, siteSettings, dispatch]);

  const saveSearchQuery = useCallback(
    (query) => {
      if (!isAiUnsplashSearchQueryEnabled || !query) {
        return;
      }

      const trimmedSearchQuery = query.slice(0, UNSPLASH_SEARCH_QUERY_MAX_LENGTH);

      dispatch(
        site.actions.setSiteProperty(UNSPLASH_SEARCH_QUERY_PROPERTY_NAME, trimmedSearchQuery)
      );
    },
    [isAiUnsplashSearchQueryEnabled, dispatch]
  );

  return { getInitialSearchQuery, saveSearchQuery };
}

export default useSearchQuery;
